module.exports = __webpack_public_path__ + "static/media/play-push.91ff9aea.png";